/**
 * Конверсия кристаллов кассы в игровые (§Т2.4 POST /wallet/convert).
 *
 * Назначение файла: единственный клиентский вызов обмена ✦ → ☾.
 * Курс и правила — на сервере; клиент только передаёт сумму и confirmCash.
 */

import { apiFetch } from "./client.js";

export type ConvertResult = {
  readonly cash: number;
  readonly hive: number;
  readonly converted: number;
};

export async function convertCash(
  amount: number,
  confirmCash: boolean,
  token: string,
  idempotencyKey: string,
): Promise<ConvertResult> {
  return apiFetch<ConvertResult>("/wallet/convert", {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ amount, confirmCash }),
  });
}
